import { UserScope, type LogtoConfig } from '@logto/react';

export const logtoConfig: LogtoConfig = {
  endpoint: import.meta.env.VITE_LOGTO_ENDPOINT,
  appId: import.meta.env.VITE_LOGTO_APP_ID,
  resources: [import.meta.env.VITE_LOGTO_API_RESOURCE],
  scopes: [UserScope.Email, UserScope.Profile],
};

export const API_RESOURCE = import.meta.env.VITE_LOGTO_API_RESOURCE;
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
